<template>

    <v-page-body>

        <transition name="modal">
            <v-modal-unsub-group-create v-if="showModal === 'create'" @created="getUnsubGroups" />
            <v-modal-unsub-group-delete v-if="showModal === 'delete'" :group="selectedGroup" @deleted="getUnsubGroups" />
            <v-modal-unsub-group-edit v-if="showModal === selectedGroup.id" :group="selectedGroup" @saved="getUnsubGroups" />
        </transition>

        <v-page-filters floating>
            <v-searchbar :model="params.q" @input="params.q = $event" :action="getUnsubGroups" />
            <v-button size="sm" @click.native="createUnsubGroup">Create Unsubscribe Group</v-button>
        </v-page-filters>

        <v-notice v-if="!groups.length" title="Add an Unsubscribe Group" message="You can create multiple unsubscribe groups for use in your automations and broadcasts.">
            <template #footer>
                <v-button @click.native="createUnsubGroup">Create Unsubscribe Group</v-button>
            </template>
        </v-notice>

        <v-list v-else>
            <v-list-item v-for="group in groups" :key="group.id">
                <div>
                    <span>{{ group.name }}</span><br>
                    <span v-if="group.default === 'automatic'" class="small text-primary">Default for Automations</span>
                    <span v-else-if="group.default === 'broadcast'" class="small text-primary">Default for Broadcasts</span>
                    <span v-if="group.default" class="small text-muted">&nbsp;&bull;&nbsp;</span>
                    <span class="text-muted">{{ group.members_count }} {{ 'member' | pluralize(group.members_count) }}</span>
                </div>
                <div class="d-flex align-items-center justify-content-end">
                    <v-button-toolbar size="sm">
                        <v-button size="sm" btn-style="secondary" @click.native="editUnsubGroup(group)">Edit</v-button>
                        <v-button size="sm" btn-style="secondary" @click.native="$router.push({ name: 'settings-unsub-groups-members', params: { id: group.id } })">Members</v-button>
                    </v-button-toolbar>
                </div>
            </v-list-item>
        </v-list>

    </v-page-body>

</template>

<script>

import ModalUnsubGroupCreate from '@modals/unsub-group/ModalUnsubGroupCreate';
import ModalUnsubGroupDelete from '@modals/unsub-group/ModalUnsubGroupDelete';
import ModalUnsubGroupEdit from '@modals/unsub-group/ModalUnsubGroupEdit';
import ProjectApi from '@api/ProjectApi';

export default {

    components: {
        'v-modal-unsub-group-create': ModalUnsubGroupCreate,
        'v-modal-unsub-group-delete': ModalUnsubGroupDelete,
        'v-modal-unsub-group-edit': ModalUnsubGroupEdit,
    },

    data() {
        return {
            groups: [],
            selectedGroup: {},
            params: {},
        }
    },

    mounted() {
        this.getProject();
    },

    methods: {

        getProject() {
            this.$store.commit('loading', true);
            ProjectApi.getProject(this.project.id)
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.groups = response.data.data.unsub_groups;
                    this.$events.$emit('pageLoaded');
                }, () => {
                    this.$store.commit('loading', false);
                    this.$events.$emit('pageError');
                });
        },

        getUnsubGroups() {
            this.$store.commit('loading', true);
            ProjectApi.getUnsubGroups(this.project.id, this.params)
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.groups = response.data.data;
                }, () => {
                    this.$store.commit('loading', false);
                });
        },

        editUnsubGroup(group) {
            this.selectedGroup = group;
            this.$store.commit('showModal', group.id);
        },

        createUnsubGroup() {
            this.$store.commit('showModal', 'create');
        },

    },

}

</script>